import * as styles from 'styles/molecules/MobileAppBadges.css'
import { IS_ANDROID, IS_IOS, IS_MOBILE } from 'helpers/userAgentHelpers'
import MobileAppBadge from 'components/atoms/MobileAppBadge'

const MobileAppBadges = () => {
  const iosBadge = IS_IOS || !IS_MOBILE
    ? <MobileAppBadge platform='ios' />
    : null

  const androidBadge = IS_ANDROID || !IS_MOBILE
    ? <MobileAppBadge platform='android' />
    : null

  return (
    <div className={ styles.mobileAppBadges }>
      { iosBadge }
      { androidBadge }
    </div>
  )
}

export default MobileAppBadges
